import { Icon, Typography13, Typography15 } from "@slid/slid-ips";
import { TooltipIcon } from "components/icons/NoteMateIcons/TooltipIcon";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getApplicationType } from "utils/utils";

export const NewFeatureBanner = ({ hideBanner, location }: { hideBanner: () => void; location: "plainNote" | "videoNote" }) => {
  const { t } = useTranslation("NoteMate");
  const applicationType = getApplicationType();

  return (
    <NewFeatureBannerContainer>
      <LeftContainer>
        <TooltipIcon />
        <TextContainer>
          <Typography15
            weight={700}
            text={applicationType === "desktop" ? t("DesktopBannerTitle") : location === "plainNote" ? t("PlainNoteBannerTitle") : t("VideoNoteBannerTitle")}
            color={`--gray17`}
          />
          <Typography13 weight={400} text={t(`BannerContent`)} color={`--gray17`} />
        </TextContainer>
      </LeftContainer>
      <CloseButtonContainer icon="x24" color={`--purple7`} onClick={hideBanner} />
    </NewFeatureBannerContainer>
  );
};

const NewFeatureBannerContainer = styled.div`
  display: flex;
  min-width: 298px;
  width: max-content;
  height: auto;
  justify-content: space-between;

  padding: 8px 8px 8px 16px;
  border-radius: 8px;
  border: 2px solid var(--purple7);
  background: var(--purple1);
  gap: 12px;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0px;
  gap: 2px;
`;

const CloseButtonContainer = styled(Icon)`
  && {
    cursor: pointer;
  }
`;
